import horsesApi from '@/services/api/horses'

export default {
  namespaced: true,
  state: () => ({
    searchResults: [],
    searchLoading: false,
    searchRequestId: 0,
    preview: null,
    previewLoading: false,
    previewRequestId: 0,
    merging: false
  }),
  mutations: {
    SET_SEARCH_RESULTS(state, results) {
      state.searchResults = results
    },
    SET_SEARCH_LOADING(state, loading) {
      state.searchLoading = loading
    },
    BUMP_SEARCH_REQUEST_ID(state) {
      state.searchRequestId += 1
    },
    SET_PREVIEW(state, preview) {
      state.preview = preview
    },
    SET_PREVIEW_LOADING(state, loading) {
      state.previewLoading = loading
    },
    BUMP_PREVIEW_REQUEST_ID(state) {
      state.previewRequestId += 1
    },
    SET_MERGING(state, merging) {
      state.merging = merging
    }
  },
  actions: {
    async search({ state, commit }, { query, sourceHorseId }) {
      commit('BUMP_SEARCH_REQUEST_ID')
      const requestId = state.searchRequestId
      commit('SET_SEARCH_LOADING', true)
      try {
        const response = await horsesApi.search(query)
        const results = response.data.data.filter(horse => String(horse.id) !== String(sourceHorseId))
        if (state.searchRequestId === requestId) commit('SET_SEARCH_RESULTS', results)
      } finally {
        if (state.searchRequestId === requestId) commit('SET_SEARCH_LOADING', false)
      }
    },
    async preview({ state, commit }, data) {
      commit('BUMP_PREVIEW_REQUEST_ID')
      const requestId = state.previewRequestId
      commit('SET_PREVIEW_LOADING', true)
      commit('SET_PREVIEW', null)
      try {
        const response = await horsesApi.previewMerge(data)
        if (state.previewRequestId === requestId) commit('SET_PREVIEW', response.data.data)
        return response.data.data
      } finally {
        if (state.previewRequestId === requestId) commit('SET_PREVIEW_LOADING', false)
      }
    },
    async merge({ commit }, data) {
      commit('SET_MERGING', true)
      try {
        const response = await horsesApi.merge(data)
        return response.data
      } finally {
        commit('SET_MERGING', false)
      }
    },
    clearPreview({ commit }) {
      commit('BUMP_PREVIEW_REQUEST_ID')
      commit('SET_PREVIEW', null)
    },
    reset({ commit }) {
      commit('BUMP_SEARCH_REQUEST_ID')
      commit('BUMP_PREVIEW_REQUEST_ID')
      commit('SET_SEARCH_RESULTS', [])
      commit('SET_PREVIEW', null)
    }
  },
  getters: {
    searchResults: state => state.searchResults,
    searchLoading: state => state.searchLoading,
    preview: state => state.preview,
    previewLoading: state => state.previewLoading,
    merging: state => state.merging
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/horseMerge.js